export default {
  addText: "Add",
  chooseYourOwn: "Pick Any School",
  chooseYourOwnTextPrompt: "Get read only access to a forum of your choosing",
  learnMoreText: "Learn More",
  purchasedGo: "Purchased - Go"
};
